<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import { toast, variants } from "@/helpers/toaster";
import store from '@/state/store';
import ErrorAlert from "@/components/errorAlert";

export default {
  page: {
    title: "Porudžbenice objekta",
  },
  components: {PageHeader, Layout, VueBootstrapAutocomplete, ErrorAlert},
  props: {
  },
  data() {
    return {
      title: 'Porudžbenice objekta',
      fields: [
        {key: 'real_item_id', label: 'ID', sortable: false},
        {key: 'name', label: 'Artikal', sortable: true, sortByFormatted: true, formatter: (value, key, item) => item.name2?.toLowerCase()},
        {key: 'code', label: 'Šifra', sortable: true},
        {key: 'number_in_package', label: 'Pak', sortable: false},
        {key: 'jm', label: 'JM', sortable: false},
        {key: 'price', label: 'Cena', sortable: false},
        {key: 'rebate', label: 'Rabat', sortable: false},
        {key: 'price_with_rebate', label: 'Cena sa Rabatom', sortable: false},
        {key: 'limit', label: 'Limit', sortable: false, editable: false},
        {key: 'amount', label: 'Količina', sortable: false, editable: true},
      ],
      search: '',
      showOrdered: true,
      selectedGroup: null,
      selectedOrderForm: null,
      employees: [],
      employeeQuery: '',
      selectedEmployee: null,
      groups: [],
      orderForms: [],
      orderFormItems: [],
      budget: 0,
      status: null,
      note: '',
      debounceTimer: null, // Timer for debouncing
    }
  },
  watch: {
    showOrdered(v) {
      this.search = '';
    },
    employeeQuery(v) {
    },
    selectedEmployee() {
      this.search = '';
      this.loadOrderForms();
    },
    selectedGroup() {
      this.search = '';
      this.loadOrderForms();
    },
    selectedOrderForm() {
      this.search = '';
      this.loadOrderForm();
    },
  },
  computed: {
    computedGroups() {
      if (!this.groups) return [];

      return this.groups.map((g) => {
        return {
          value: g,
          text: g.name,
        }
      });
    },
    isSaveDisabled() {
      if (!this.selectedOrderForm && !this.selectedGroup) {
        return true;
      }

      if (this.budget && this.totalPrice > this.budget)
        return true;

      if (this.status === 'SOFT_ORDERED')
        return true;

      return !this.orderFormItems.every(i => this.validateItem(i));
    },
    computedFields() {
      return this.fields;
    },
    totalPrice() {
      let price = 0;
      for (const orderFormItem of this.orderFormItems) {
        if (orderFormItem.amount) {
          price += orderFormItem.amount * orderFormItem.price
        }
      }
      return price;
    },
    searchedOrderFormItems () {
      let searched = this.orderFormItems.filter((orderFormItem) => {
        let include = false;
        // search name
        include ||= orderFormItem.name2?.toLowerCase().includes(this.search.toLowerCase());
        // search id
        include ||= orderFormItem.real_item_id?.toString().includes(this.search.toLowerCase());

        return include;
      });

      if (this.showOrdered) {
        searched = searched.filter((item) => item.amount > 0)
      }

      return searched
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      await axios.get('/admin/employees/getForAdmin').then(response => {
        this.employees = response.data;
      })
      await axios.get('/admin/groups').then(response => {
        this.groups = response.data;
      })
    } catch (e) {
      // eslint-disable-next-li`ne no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    openWindow(itemId) {
      const url = `https://www.bigznet.rs/image/catalog/net/${itemId}`;
      window.open(
        url, 
        '_blank', 
        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600,popup'
      );
    },
    async onEmployeeSelect() {
      await this.loadOrderForms();
    },
    async loadOrderForms() {
      if (this.selectedEmployee == null) return;
      if (this.selectedGroup == null) {
        return;
      }

      this.$store.commit('loader/START_LOADING');
      try {
        const orderFormsResponse = await axios.get(`/admin/orderFormsForEmployee/withGroup/${this.selectedEmployee.id}/${this.selectedGroup.id}`);
        if (orderFormsResponse.data && !!orderFormsResponse.data.order_form) {
          this.selectedOrderForm = orderFormsResponse.data.order_form;
          this.note = orderFormsResponse.data.order_form.employeeNote;
          await this.loadOrderForm();
        }
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async loadOrderForm() {
      if (this.selectedEmployee == null) return;
      if (this.selectedOrderForm == null) {
        return;
      }

      const orderFormResponse = await axios.get(`/admin/orderFormsForEmployee/withGroup/${this.selectedEmployee.id}/${this.selectedOrderForm.id}/itemsAndLimits`);
      this.budget = orderFormResponse.data.budget
      this.orderFormItems = orderFormResponse.data.items;
      this.showPrices = orderFormResponse.data.show_prices;
      this.showRebate = orderFormResponse.data.show_rebate;
      this.showCodes = orderFormResponse.data.show_codes;
      this.showIds = orderFormResponse.data.show_ids;
      this.showLimit = orderFormResponse.data.show_limit;
      this.showPricesWithRebate = orderFormResponse.data.show_prices_with_rebate;
      this.status = orderFormResponse.data.admin;
      if (this.status === 'SOFT_ORDERED' ) {
        store.commit('errorBag/RECORD', { status:["Porudžbina je zatvorena i u postupku odobrenja. Više nisu dozvoljene izmene."]});
      }
      for (const orderFormItem of this.orderFormItems) {
        this.$set(orderFormItem, 'isValid', true);
        this.$set(orderFormItem, 'validationMessage', "");
      }
    },
    calculatePercentage(current, total) {
      if (total === 0) {
          return 0;
      }
      const percentage = ((current / total) * 100)
      return (percentage > 100 ? 100 : percentage.toFixed(2)) + "%";
    },
    save() {
      const items = this.orderFormItems.filter(i => i.amount).map(i => {
          return { 
            item_id: i.id,
            amount: i.amount,
          }
        });
      this.$store.commit('loader/START_LOADING');

      axios.patch(`/admin/orderFormsForEmployee/${this.selectedEmployee.id}/${this.selectedOrderForm.id}`, {items: items, employeeNote: this.note})
        .then(response => {
          // Handle success
          toast('Uspešno snimljene promene.', variants.SUCCESS)
        })
        .catch(error => {
          // TODO: vidimo kako cemo
          // if (error.response && error.response.status == 503) {
          //   this.$set(item, 'isValid', false);
          //   this.$set(item, 'validationMessage', "Nije dozvoljena promena porudžbenice.");
          //   return;
          // }
          console.error('Error updating order form:', error);
        })
        .finally(() => {
          this.$store.commit('loader/END_LOADING');
        });
    },
    validateItem(item) {
      if (item.number_in_package && item.amount % item.number_in_package !== 0) {
        return false;
      }

      if (item.limit && item.limit !== 0 && item.amount > item.limit) {
        return false;
      }

      if (item.limit == 0 && item.amount > 0) {
        return false;
      }

      if (item.amount < 0) {
        return false;
      }

      return true;
    },
    onAmountEdit(item, value) {
      this.$set(item, 'isValid', true);
      this.$set(item, 'validationMessage', "");

      if (!value) {
        value = null;
      }

      this.$set(item, 'amount', value);

      if (item.number_in_package && value % item.number_in_package !== 0) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', `Broj artikla u paketu je ${item.number_in_package}. Odaberite količinu deljivu sa ${item.number_in_package}.` );
        return;
      }

      if (item.limit && item.limit !== 0 && value > item.limit) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', "Prekoračen limit.");
        return;
      }

      if (item.amount < 0) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', "Vrednost ne može biti negativna.");
        return;
      }

      if (item.limit == 0 && item.amount > 0) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', "Prekoračen limit.");
        return;
      }
    },
  }
}
</script>

<template>
  <Layout>
    <ErrorAlert></ErrorAlert>

    <PageHeader :title="title"/>

    <div class="row mb-2">
      <div class="col-12 col-md-6 d-flex">
        <label class="col-form-label mr-2" for="employee">Objekat:</label>
        <VueBootstrapAutocomplete
          class="autocomplete"
          id="employee"
          v-model="employeeQuery"
          :data="employees"
          :serializer="(item) => item.object_name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedEmployee = $event"
        />
      </div>
      <div class="col-12 col-md-6 d-flex justify-content-end">
        <label class="col-form-label mr-2" for="groups">Grupa:</label>
        <b-form-select id="groups" v-model="selectedGroup" :options="computedGroups">
          <template #first>
            <b-form-select-option :value="null" disabled>-- Izaberi grupu --</b-form-select-option>
          </template>
        </b-form-select>
        <!-- <VueBootstrapAutocomplete
          class="autocomplete"
          id="groups"
          v-model="groupQuery"
          :data="groups"
          :serializer="(item) => item.name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedGroup = $event"
        /> -->
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-6 col-12">
        <label for="textarea">Napomena: </label>
        <b-form-textarea
          id="textarea"
          v-model="note"
          rows="3"
          max-rows="3"
        ></b-form-textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="search-box chat-search-box mb-2">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 align-items-center justify-content-end d-flex">
            <b-form-checkbox
                    v-model="showOrdered"
                    :value="true"
                    :unchecked-value="false"
                    switch
            >
            Prikaži samo poručene artikle
          </b-form-checkbox>
          <b-button class="ml-2" type="button" variant="success" @click="save()" :disabled="isSaveDisabled">Snimi</b-button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">

        <label v-if="this.budget">Iskorišćen budžet: {{this.calculatePercentage(this.totalPrice, this.budget)}} </label>
        <b-progress :variant="this.budget && this.totalPrice > this.budget ? 'danger' : ''" v-if="this.budget" class="" :max="this.budget">
          <b-progress-bar :value="this.totalPrice"></b-progress-bar>
        </b-progress>
        <div v-if="this.budget && this.totalPrice > this.budget" class="mb-4 text-danger">Budžet je prekoračen. Redukujte količinu proizvoda.</div>

        <b-table :items="searchedOrderFormItems" :fields="computedFields" striped responsive
                 class="border-left border-right border-bottom"
        >
        <template v-slot:cell(real_item_id)="data">
          <a @click.prevent="openWindow(data.item.real_item_id)" href="#">
            {{ data.item.real_item_id }}
          </a>
        </template>
          <template v-slot:cell(name)="data">
            <a target="_blank" :href="`https://www.bigznet.rs/index.php?route=product/product&product_id=${data.item.real_item_id}`">{{ data.item.name2 }}</a>
          </template>
          <template v-slot:cell(price)="data">
            {{ data.value }} RSD
          </template>
          <template v-slot:cell(amount)="data">
            <div v-if="data.field.editable">
              <b-form-input :class="{'is-invalid': !data.item.isValid}" v-model="data.value" @input="onAmountEdit(data.item, data.value)" type="number"/>
              <span class="text-danger" v-if="data.item.validationMessage">
                {{ data.item.validationMessage }}
              </span>
            </div>
            <div v-else>
              <h1>{{ data.value }}</h1>
            </div>
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.search-box .form-control {
  border-radius: 0.25rem;
}
.autocomplete {
  width: 100%;
}
</style>
